import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HighLevelInfo from './HighLevelInfo';
import SpacesStructure from './SpacesStructure/SpacesStructure';
import PageToolbar from '../../shared/PageToolbar';
import pageStyles from '../../../styles/pages.module.css';

const LAST_TAB_KEY = 'lastOverviewTab';

export default function OverviewPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(() => localStorage.getItem(LAST_TAB_KEY) || 'info');

  // Save active tab to localStorage
  useEffect(() => {
    localStorage.setItem(LAST_TAB_KEY, activeTab);
  }, [activeTab]);

  const tabs = [
    { id: 'info', label: 'מידע כללי' },
    { id: 'spaces', label: 'מבנה החללים' },
  ];

  // Action button only shows on info tab
  const actions =
    activeTab === 'info' ? (
      <button onClick={() => navigate('/wizard')} className={pageStyles.tab}>
        ⚙️ ערוך באשף
      </button>
    ) : null;

  return (
    <div className={pageStyles.pageContainer}>
      <PageToolbar tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} actions={actions} />
      {activeTab === 'info' && <HighLevelInfo />}
      {activeTab === 'spaces' && <SpacesStructure />}
    </div>
  );
}
